import DPFSharingMemoriesImg1 from '../assets/landing/DPF-sharing-memories-img-1.png'

export default function SharingMemoriesSection() {
  return (
    <section className='px-4 py-10 space-y-6 bg-[#FFF6F6]'>
      <div className='text-center space-y-6'>
        <h2 className='text-2xl font-semibold text-gray-12 mb-6'>同じ思い出を家族みんなで</h2>
        <img src={DPFSharingMemoriesImg1} alt='' className='w-full rounded-lg' loading='lazy' />
        <p className='text-base text-gray-12 text-left font-normal leading-[160%] tracking-0'>
          家族みんなで一緒に思い出を振り返れば、「この写真いつのだろう？」「大きくなったね☺️」と、昔を思い出して心があたたまる会話が自然と生まれます。
        </p>
      </div>
    </section>
  )
}
